import {
    required, minValue, numeric, maxValue,
} from 'vuelidate/lib/validators';
import ScheduleInstructionModel from '@/common/models/rules/schedule-instruction-model';

export default function getScheduleValidation(scheduleInstruction) {
    const validation = {
        method: {
            required,
        },
    };

    switch (scheduleInstruction.method) {
        case ScheduleInstructionModel.Methods.dateInterval:
        case ScheduleInstructionModel.Methods.intelligent:
            validation.unit = {
                required,
            };
            validation.duration = {
                required,
                numeric,
                minValue: minValue(1),
            };
            break;
        case ScheduleInstructionModel.Methods.dayOfMonth:
            validation.time = {};
            validation.day = {
                required,
                numeric,
                minValue: minValue(1),
                maxValue: maxValue(31),
            };
            break;
        case ScheduleInstructionModel.Methods.dayOfWeek:
            validation.time = {};
            validation.day = {
                required,
            };
            validation.week = {
                required,
            };
            break;
        default:
            break;
    }
    return validation;
}
